import { DocumentNode } from 'graphql';
import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { IProductSchemaPartial } from '../../type/product';

export interface IUpdateProductInventoryMutationFields {
  _id: string;
  notificationLowStock?: number
  notificationNoStock?: number
  stockInStock?: number
  stockReserved?: number
  stockLeadTime?: number
  supplyAbilityNumber?: number
  supplyAbilityTime?: number
  availability?: number
  availabilityDateFrom?: Date
  availabilityDateTo?: Date
}


export interface IUpdateProductInventoryMutationResponseFields {
  updatedProduct: IProductSchemaPartial;
}


export function updateProductInventoryMutation(fragment: string): DocumentNode {
  return gql`
        mutation updateProductInventory (
        $_id: String!,
$notificationLowStock : Int,
$notificationNoStock : Int,
$stockInStock : Int,
$stockReserved : Int,
$stockLeadTime : Int,
$supplyAbilityNumber : Int,
$supplyAbilityTime : Int,
$availability : Int,
$availabilityDateFrom : Date,
$availabilityDateTo : Date
        ) {
        updateProductInventory (
        _id: $_id,
notificationLowStock : $notificationLowStock ,
notificationNoStock : $notificationNoStock ,
stockInStock : $stockInStock ,
stockReserved : $stockReserved ,
stockLeadTime : $stockLeadTime ,
supplyAbilityNumber : $supplyAbilityNumber ,
supplyAbilityTime : $supplyAbilityTime ,
availability : $availability ,
availabilityDateFrom : $availabilityDateFrom ,
availabilityDateTo : $availabilityDateTo 
        ) {
        ...fragment
        }
        }
        fragment fragment on UpdateProductInventoryMutationResponse {
        code
        success
        message
        ${fragment}
        }
    `;
}

export function useUpdateProductInventoryMutation<TData extends Partial<IUpdateProductInventoryMutationResponseFields>>(
  fragment: string, options?: MutationHookOptions<{ updateProductInventory: TData },
        IUpdateProductInventoryMutationFields>,
) {
  return useMutation<{ updateProductInventory: TData },
      IUpdateProductInventoryMutationFields>(
        updateProductInventoryMutation(fragment), options,
      );
}
